import { Dispatch, SetStateAction } from 'react';
import { FIELDS, HpIdFieldConfigType } from '@uma/react-commons/dist/index';
import { PersonalDetailsType } from '../pages/Home/index';

const getFieldsToFetch = (
  setPersonalDetails: Dispatch<SetStateAction<PersonalDetailsType>>
): HpIdFieldConfigType[] => {
  return [
    {
      field: FIELDS.FIRST_NAME,
      setter: (value: string) =>
        setPersonalDetails((prev) => ({ ...prev, firstName: value }))
    },
    {
      field: FIELDS.COUNTRY,
      setter: (value: string) =>
        setPersonalDetails((prev) => ({
          ...prev,
          country: value
        }))
    }
  ];
};

export default getFieldsToFetch;
